import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import './login.css'
import { clearCookieKeys, encryptValue, getFromLocalStorage, getQueryVariable, removeFromLocalStorage, saveInLocalStorage, viewModeOn } from "../utilFunctions";
import { toast } from "react-toastify";
import { CLIENT_ID, KSHEMA_1_URL, REACT_APP_VAM_CONTEXT_AUTHORIZATION, REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_ENDPOINT, tokenClientSecret, tokenScope } from "../urls";
import Form from 'react-bootstrap/Form';
import { useMsal } from "@azure/msal-react";
import { addListener, callLogin, getRequestData, validateLogin } from "../loginPageHelper";
import { functionalities, METHOD, PAGE_NAME_KEYS, STORAGE_KEY } from "../consts";
import Cookies from "js-cookie";
import LoadingPage from "../reusableComponents/loader/loadingPage";
import { axiosClient, axiosWithoutToken } from "../service";
import { menuItems } from "../dashboard/sidemenu";

const Login = (props) => {
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState(true);
  const [errorTextNotAuthorised, setErrorTextNotAuthorised] = useState(true);
  const [emptyErrorText, setEmptyErrorText] = useState(true)
  const [omdcUser, setOmdcUser] = useState(false)
  const { instance } = useMsal();
  const initialized = useRef(false);
  const [showLoader, setShowLoader] = useState(false);

  const getMenuItemsToShow = () => {
    return menuItems.filter(item => viewModeOn(item.key));
  }

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      addListener(instance, onSuccessfulLogin);
    }
    const tokenExpire = getFromLocalStorage(STORAGE_KEY.TOKEN_EXPIRE);
    if (STORAGE_KEY.TOKEN_EXPIRE === tokenExpire) {
      toast.success('Token has expired, Please login');
      removeFromLocalStorage(STORAGE_KEY.TOKEN_EXPIRE);
    }
  }, []);

  
  // useEffect(() => {
  //   sessionStorage.setItem("is_omdcUser", omdcUser)
  // },[omdcUser])

  const postSSOLogin = (payload) => {
    axiosWithoutToken().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_AUTHORIZATION}/token` , {
        "clientID":CLIENT_ID,
        "tokenClientSecret": tokenClientSecret,
        "tokenScope": tokenScope,
        "tokenGrantType":"client_credentials",
        "tokenURL":"https://login.microsoftonline.com/225a33a3-a252-427b-a09a-5ae946b50ce4/oauth2/v2.0/token"       
    }
       ).then(data => {
        Cookies.set("token", data.data.access_token, { expires: (new Date(Date.now()+ data.data.expires_in  *1000)), path: "/" }); 
        // setShowApplication(true)
        // getQueryVariable("user") && getRoleData()
        axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}`)({
          url: 'userinfo',
          method: METHOD.GET,
          params: {email: payload.email}
      }).then(data => {
          if(Number(data.data.userRoleMapping.cmsStatus) === 1){
            axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}`)({
              url: `roleByUserID/${payload.email}`,
              method: METHOD.GET,
          }).then(roleData => {
              axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}`)({
                url: `role/${data?.data.userRoleMapping?.roleID}`,
                method: METHOD.GET,
            }).then(functionalitiesData => {
                if(roleData.data && functionalitiesData?.data?.status !== 0){
                  const permissionsList = functionalitiesData.data.roleFunctionalities
                  let roleFunctionalitiesEncripted = encryptValue(JSON.stringify(permissionsList))
                  let roleDataEncripted = encryptValue(JSON.stringify({...data.data,roleName: roleData.data}))
                  let isAuthenticated = encryptValue("true")
                  saveInLocalStorage("roleFunctionalities", roleFunctionalitiesEncripted)    
                  saveInLocalStorage("isAuthenticated", isAuthenticated)      
                  saveInLocalStorage("roleData", roleDataEncripted)
                  navigate(`dashboard/${PAGE_NAME_KEYS.LINE_OF_BUSINESS}`);
                }else{
                  if(functionalitiesData?.data?.status === 0) {
                    toast.error("User Role is In-Active");
                    setTimeout(()=>{
                      clearCookieKeys();
                      instance.logoutRedirect();
                    },1000);
                    return;
                  }
                  clearCookieKeys();
                  instance.logoutRedirect()
                }
              }).catch(error => {
                console.log(error)
              })
            }).catch(err=>{
              toast.error("Role Not Assigned")
            })
            axiosWithoutToken().post(`${KSHEMA_1_URL}/iAgri/REST/authentication`,{
                childid: "999",
                sourceid: "999",
            },{
                 headers: {
                  Authorization: 'Basic ' + btoa('iagriandroid' + ':' + 'KshemA@1913')
                }
            }).then(response => {
              let token = response.data[0]?.token
              if(token) {
                saveInLocalStorage("kshemaToken",encryptValue(token))
              }
              
            })
          }else{
            toast.error("User is In-Active")
            setTimeout(() => {
              clearCookieKeys();
              instance.logoutRedirect()
            },1000)
          }
        }).catch(error => {         
        })
        }).catch(error => {
        }).finally(()=> {
          setShowLoader(false)
        })
  }

 
  const onSuccessfulLogin = (payload) => {
    setShowLoader(true)
    postSSOLogin(getRequestData(payload))
      .unwrap()
      .then((fulfilled) => {
        validateLogin(fulfilled, instance);
      })
      .catch((error) => {

      });
  };
 
  // const toDash = (e) => {
  //   e.preventDefault()
  //   if(omdcUser){
  //     window.open(`${REACT_APP_VAM_SAML_OMDC}/saml2/authenticate/one`,"_self")
  //   }
  //   //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   //const emailRegex = /^[a-zA-Z0-9._%+-]+@(?:kshema.co|[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+)$/
  //   const emailRegex = omdcUser ? /^[^\s@]+@omdc\.co.in$/ : /^[^\s@]+@kshema\.co$/
  //   const inputEmail = e.target[0].value;
  //   if (inputEmail === "") {
  //     setEmptyErrorText(false);
  //     return;
  //     //return emailRegex.test(email);
  //   }
  //   if (inputEmail !== "") {
  //     if (!emailRegex.test(inputEmail)) {
  //       setErrorTextNotAuthorised(false);
  //       return;
  //       //setError('Please enter a valid email address.');
  //     } else {
  //       // Perform login logic here
  //       console.log('Logging in with email:', inputEmail);
  //       window.open(`${REACT_APP_VAM_SAML}/saml2/authenticate/one`,"_self")
  //        //navigate('/dashboard/claim_intimation?user=sathishkumar.p@kshema.co&token=eyJ0eXAiOiJKV1QiLCJub25jZSI6InluOHhpaTRGU1pRX2RMMDN5T2RxTExqZEtwR1pJTklRLVJJMEdTeFFWSDQiLCJhbGciOiJSUzI1NiIsIng1dCI6Ik1HTHFqOThWTkxvWGFGZnBKQ0JwZ0I0SmFLcyIsImtpZCI6Ik1HTHFqOThWTkxvWGFGZnBKQ0JwZ0I0SmFLcyJ9.eyJhdWQiOiJodHRwczovL2dyYXBoLm1pY3Jvc29mdC5jb20iLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8yMjVhMzNhMy1hMjUyLTQyN2ItYTA5YS01YWU5NDZiNTBjZTQvIiwiaWF0IjoxNzIwODU4MjIyLCJuYmYiOjE3MjA4NTgyMjIsImV4cCI6MTcyMDg5NDUyMiwiYWlvIjoiRTJkZ1lMQVY3VFZqQ0xPcGJYWE5VbVNxMjIwTUFBPT0iLCJhcHBfZGlzcGxheW5hbWUiOiJLc2hlbWEgQ01TIEFwcCIsImFwcGlkIjoiZTc5NjA3ZTItNjNiZS00MjE5LTk1ZTAtMzQ5MGUzNzZhYzA1IiwiYXBwaWRhY3IiOiIxIiwiaWRwIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvMjI1YTMzYTMtYTI1Mi00MjdiLWEwOWEtNWFlOTQ2YjUwY2U0LyIsImlkdHlwIjoiYXBwIiwib2lkIjoiZGZiZTMzNjktNDQwMy00OGRlLTgwYWQtNWM4NWIxYjNmMjg5IiwicmgiOiIwLkFYQUFvek5hSWxLaWUwS2dtbHJwUnJVTTVBTUFBQUFBQUFBQXdBQUFBQUFBQUFERUFBQS4iLCJzdWIiOiJkZmJlMzM2OS00NDAzLTQ4ZGUtODBhZC01Yzg1YjFiM2YyODkiLCJ0ZW5hbnRfcmVnaW9uX3Njb3BlIjoiQVMiLCJ0aWQiOiIyMjVhMzNhMy1hMjUyLTQyN2ItYTA5YS01YWU5NDZiNTBjZTQiLCJ1dGkiOiJ2N3haRVlBVUYwaTNDNFJPUVZrZkFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyIwOTk3YTFkMC0wZDFkLTRhY2ItYjQwOC1kNWNhNzMxMjFlOTAiXSwieG1zX2lkcmVsIjoiMTQgNyIsInhtc190Y2R0IjoxNTg3NDI2NjI1fQ.mUYk5a-TTimrqjCy8D4fJMySUUfMAPHe1MyxJFdg5-LT3tMDY9z6LQ5GIzRHqu_7RFrtjPG_iY0x1p0yFo9Wz-sDA1qIFTQW5bzarpSaSWVHJyyvZSczizAejZA0p1y0UIZrNdfLiRXWhdt1z5uJSNvjADIHELAJBtlhXjBT5teH7nyy_O9hfoG3kRj1Ed4dZth3ZcYwMEZveXogAOEU7Hzv7wtfrJqEEHYe79LORFgHCEpNO-oEfnYL9f_FcIQkPVRsja4ZpzWkK2GFbH9RsWnSMHh0vtgC7gDVKSCDRtTI525opSbkCne5WL7nHU5NzVGqq3qXoA3zC6Jixv6LRg&roleName=Admin');
  //       // Programmatically navigate to a different route
  //       //setError('');
  //     }
  //   }
  // };


  useEffect(() => {
    getQueryVariable('error') && toast.error("User Not Authorized to CMS")
  }, [])


  return (
    <>
      {
        showLoader ? (
          <LoadingPage/>
        ) : (
          <div style={{ minHeight: "100vh" }} className="d-md-flex">
            <div className="col-md-6 d-flex flex-column align-items-center bg-green justify-content-center p-4">
              <h2 className="text-white">Welcome to Claims Management System</h2>
              {/* <p className="text-white">Text about claims goes here</p> */}
            </div>
            <div className="col-md-6 d-flex flex-column align-items-center justify-content-center p-4">
              <div>
                <div className="row">
                  <img alt="" className="pl-2 py-5" src="../kshemaImages/Kshema Logo Black and Blue.svg" width="60%" />
                  <h4 className="pb-3">Login</h4>
                </div>
                <div className="row">
                  <form className="mb-3" onSubmit={(e) => callLogin(e, instance)}>
                    {/* {
                      !omdcUser && (
                        <>
                        <label for="exampleFormControlInput1" class="form-label">Email Address</label>
                        <input type="" class="form-control p-2" id="exampleFormControlInput1" onChange={(e) => { setErrorText(true); setEmptyErrorText(true) }} placeholder="name@example.com" />
                        {!emptyErrorText && (<p style={{ color: 'red' }}>Email field should not be empty.</p>)}
                        {!errorTextNotAuthorised && (<p style={{ color: 'red' }}>User not Authorized to CMS.</p>)}
                        {!errorText && (
                          <p style={{ color: 'red' }}>Please enter a valid email address.</p>
                        )}                 
                        </>
                      )
                    } */}
                    {/* <Form>
                      <Form.Check // prettier-ignore
                        type="switch"
                        className="mt-3"
                        id="custom-switch"
                        label="For OMDC"
                        checked={localStorage.getItem("is_omdcUser") === "true" ? true : false}
                        // value={true}
                        onChange={() => {localStorage.setItem("is_omdcUser", localStorage.getItem("is_omdcUser") === "true" ? false : true);window.location.reload()}}
                      />
                    </Form> */}
                    <input type="submit" value="Sign In" style={{ borderRadius: "7px" }} className="bg-green form-control text-white text-justify mt-5 p-2">
                    </input>
                  </form>
                  <div className="mb-3">
                    {/* <label for="exampleFormControlTextarea1" class="form-label">Example textarea</label>
                  <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea> */}
      
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }   
    </>
  )
};

export default Login;